<template>
    <section class="userSteps">
         <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row">
            <div class="col-12">
                <!-- <router-link class="d-flex align-items-center backBtn medium" to="/upload-image">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> Back
                </router-link> -->
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('add_trading.text1')}}<span class="bgTitle dark">{{$t('add_trading.text2')}}</span></h3>
                </div>
                <div class="card-body existingBroker d-flex align-items-center border-0 h-auto p-0">
                    <router-link to="/broker-account" class="grd_btn semibold me-3">{{$t('add_trading.text3')}}</router-link>
                    <router-link to="/select-a-broker" class="grd_btn semibold border-btn">{{$t('add_trading.text4')}}</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
        }
    },
    computed: {
        isActive() {
            return false
        }
    },
    created(){
        this.store.getFlavourData({},false)
        this.store.$patch({'accountConnectSocket': null})
    }
}
</script>